import { createNomogramWidget } from './shared/nomogram.js';
import fields from './shared/fields.js';
import colors from './shared/colors.js';

const diaperRiskWidgetApp = createNomogramWidget({
    dataApi: '/umbraco/api/diaperrisk/calculate',
    errorMessage: 'Failed to calculate diaper risk',
    chartColors: [
        colors.green,
        colors.lightGreen,
        colors.yellow,
        colors.orange,
        colors.red,
    ],
    fields: [
        fields.FP,
        fields.Age,
        fields.MUL,
        fields.ICIQ,
        fields.IPSS,
    ],
    payload: vm => ({
        FP: vm.FP,
        Age: vm.Age,
        MUL: vm.MUL,
        ICIQ: vm.ICIQ,
        IPSS: vm.IPSS,
    }),
});

export default diaperRiskWidgetApp;
